import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a2ce5a0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "latest_news usesMixBlendMode hideOnFooter",
  ref: "latestNewsElement"
}
const _hoisted_2 = { class: "latest_news__toggle_label" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " actualiteit ", -1))
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "latest_news__image_container" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "latest_news__item__title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "latest_news__toggle",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleVisibility && _ctx.toggleVisibility(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Icon, {
          type: "chevron-down",
          class: "latest_news__toggle_icon"
        }),
        _hoisted_3
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
      return (_openBlock(), _createElementBlock("a", {
        href: item.href,
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleVisibility && _ctx.toggleVisibility(...args))),
        class: "latest_news__item",
        key: item.id
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("img", {
            class: "latest_news__image",
            src: item.image
          }, null, 8, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createTextVNode(_toDisplayString(item.title) + " ", 1),
          _createVNode(_component_Icon, {
            type: "arrow-right",
            class: "latest_news__item__arrow"
          })
        ])
      ], 8, _hoisted_4))
    }), 128))
  ], 512))
}